import { divide } from '@common/lib/decimal';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';

type HightlightComponentStylesType = {
  padding: number;
  rounded?: string | number;
  y?: number;
  x?: number;
};

const hightlightComponentStyles: Record<number, HightlightComponentStylesType> =
  {
    2: {
      padding: 16,
      rounded: 12,
    },
    3: {
      padding: 16,
      rounded: 12,
    },
    4: {
      padding: 16,
      rounded: 14,
    },
    5: {
      padding: 0,
      rounded: '100%',
      y: -11,
    },
    6: {
      padding: 16,
      rounded: 14,
    },
    7: {
      padding: 16,
      rounded: 12,
    },
    9: {
      padding: 16,
      rounded: 12,
    },
    10: {
      padding: 16,
      rounded: 12,
    },
    12: {
      padding: 16,
      rounded: 12,
    },
    14: {
      padding: 8,
      rounded: 99,
    },
    15: {
      padding: 16,
      rounded: 12,
    },
    17: {
      padding: 16,
      rounded: 12,
    },
    19: {
      padding: 16,
      rounded: 12,
    },
    21: {
      padding: 16,
      rounded: 12,
    },
    25: {
      padding: 16,
      rounded: 12,
    },
  };

const calcAdapteStyles = (
  styles: HightlightComponentStylesType,
): HightlightComponentStylesType => {
  return {
    ...styles,
    padding: convertRemToPixels(divide(styles.padding, 16)),
    rounded:
      typeof styles.rounded === 'number'
        ? convertRemToPixels(divide(styles.rounded, 16))
        : styles.rounded,
  };
};

export { calcAdapteStyles, hightlightComponentStyles };
